import { cn } from "@/lib/utils";
import roboHappy from "@/assets/characters/robo-happy-optimized.webp";
import sparkleExcited from "@/assets/characters/sparkle-excited-optimized.webp";
import buddyThinking from "@/assets/characters/buddy-thinking-optimized.webp";
import novaRocket from "@/assets/characters/nova-rocket-optimized.webp";
import rocketClean from "@/assets/characters/rocket-clean-256.png";
import starClean from "@/assets/characters/star-clean-256.png";
import wiseOwl from "@/assets/characters/wise-owl-256.png";
import purpleBot from "@/assets/characters/purple-bot-256.png";

interface CharacterAvatarProps {
  character: "robo" | "sparkle" | "buddy" | "nova" | "rocket" | "star" | "wise" | "robo-purple";
  size?: "sm" | "md" | "lg" | "xl";
  animated?: boolean;
  className?: string;
}

const characterImages = {
  robo: roboHappy,
  sparkle: sparkleExcited,
  buddy: buddyThinking,
  nova: novaRocket,
  rocket: rocketClean,
  star: starClean,
  wise: wiseOwl,
  "robo-purple": purpleBot,
};

const sizeClasses = {
  sm: "w-16 h-16",
  md: "w-24 h-24",
  lg: "w-32 h-32",
  xl: "w-48 h-48",
};

export const CharacterAvatar = ({
  character,
  size = "md",
  animated = true,
  className,
}: CharacterAvatarProps) => {
  return (
    <img
      src={characterImages[character]}
      alt={character}
      className={cn(
        sizeClasses[size],
        animated && "animate-bounce-soft",
        "object-contain",
        className
      )}
    />
  );
};
